<template>
    <div class="parentMessageBox">
        <div class="content">
            <parentMessage :form="form"></parentMessage>
        </div>
    </div>
</template>
<script>
import parentMessage from '@/components/consultant/ques/parentMessage.vue'
import Button from '@/components/Button.vue'
export default {
    name: "parentMessageBox",
    components: {
        parentMessage,Button
    },
    data() {
        return {
            isShowBtn: true,
            status: 2,
            form: {
                motherOccupation: '',
                motherEmployer: '',
                dadOccupation: '',
                dadEmployer: '',
                familyTypeRadio: '',
                familyType: '',
                isOnlyChildRadio: '',
                isOnlyChild: '',
                // 学生个人情况
                studentHobby: '', //兴趣爱好
                studentAdvantage: '', //优点
                studentdisadvantage: '', //缺点
                studentBestFirend: '', //最好的朋友
                studentLikeBook: '', //喜欢的书
                studentLikeMovie: '', //喜欢的电影
                studentLikeStar: '', //喜欢的明星
                studentLookOccupation: '', //向往的职业
                studentLookMajor: '', //向往的专业
                studentlookUniversity: '', //向往的大学
                studentPhysicalQuality: '', //身体素质

                // 学生学习情况 learn
                learnManageStudent: '',//主管孩子学习
                learnAccompany: '',//陪同完成作业
                learnTutoring: '',//辅导孩子作业
                learnCheckHomework: '',//检查孩子作业
                learnPreview: '',//孩子预习情况
                learnClassEffect: '',//孩子课堂效果
                learnClassNotes: '',//孩子课堂笔记
                learnReview: '',//孩子复习情况
                learnProblem: '',//孩子每天的作业练习，遇到不懂的题目，你是当天一定要想办法解决掉，还是以后再说？
                learnExamSituation: '',//孩子考试情况
                learnGrades: '',//孩子学习成绩
                learnFeedbackClass: '',//孩子反映课堂
                learnIsJoinCarm: '',//孩子是否参加课外班,是，否
                learnIsJoinCarmSubject: '',//参加课外班学科
                learnIsJoinHobby: '',//是否参加兴趣培训服务
                learnIsJoinHobbyClass: '',//兴趣班培训服务，是，否
                learnAdvantage: '',//孩子学习上的优势
                learnInfluenceFactorList: [],// 影响孩子学习的因素（可多选）

                // 日常生活部分
                lifeActivity: '',//最近和孩子一起开展的亲子活动/一起看的书或电影：
                lifeMoved: '',//孩子近期做过的最让您或您的家人感动的事
                lifeExchange: '',//您与孩子之间是否存在交流沟通方面的问题？（若有，请简要描述；若无，请填写“无”））
                lifeWorry: '',//孩子成长（学习&生活）过程中最让您担心的是：
                // 未来规划部分
                futureMajor: '',//理想专业（方向）
                futureUniversity: '',//理想大学（城市）
                futureEducation: '',//高考路径（升学）
                futureConflict: '',//就此规划，您与孩子是否达成一致？若否，请说明矛盾冲突点：
                // 学业规划期待
                studyGradesUp: '',//您期待在经历系统的学业规划服务后，学生在哪些方面会有提升？
                // 其他部分
                otherPromote: [],//您希望孩子在学习之外哪些方面得到提升？（可多选）
                otherSupplement: '',//您认为在指导孩子的过程中，您需要补充哪些方面的内容？（可多选）
                otherAspect: '',//您觉得我们需要了解孩子的特殊情况？
            }
        }
    },

    created() {
        this.getParentCensusQuestionByStudent();
    },
    methods: {
        getParentCensusQuestionByStudent() {
            this.$ajax.post(this.G_acapi + this.ports.parent.student.studentMessage.parentQues.getParentCensusQuestionByParent,{
            },{
                headers:{
                    token: window.sessionStorage.getItem('ymtxToken')
                }
            }).then((res)=>{
                if(res.data.code==2000){
                    let data = res.data.data.censusQuestion;
                    this.form = data;
                }
            })
        },
    },

}
</script>
<style scoped lang="less">
.parentMessage {

}
</style>